export const isScopedRequestCanceled = (error, signal) =>
  Boolean(
    signal?.aborted ||
      error?.name === "AbortError" ||
      error?.name === "CanceledError" ||
      error?.code === "ERR_CANCELED"
  );

export const createScopedRequestGate = () => {
  let sequence = 0;
  let activeController = null;

  const cancel = () => {
    sequence += 1;
    activeController?.abort();
    activeController = null;
  };

  const start = (scopeKey) => {
    activeController?.abort();

    const controller = new AbortController();
    const requestSequence = ++sequence;
    activeController = controller;

    return {
      signal: controller.signal,
      isCurrent: (latestScopeKey) =>
        requestSequence === sequence &&
        !controller.signal.aborted &&
        latestScopeKey === scopeKey,
      finish: () => {
        if (activeController === controller) {
          activeController = null;
        }
      },
    };
  };

  return { cancel, start };
};
